export var theme = { token: { colorPrimary: "#638dfc", colorInfo: "#638dfc", colorSuccess: "#60C07F", colorWarning: "#f2994a", colorError: "#eb5757" } };
